/**
 * 客户类别， 1为个人，其他为企业
 */
export enum PartnerCategory {
  /** 个人 */
  Personal = 1,
  /** 未准入 */
  Unapproved = 0,
}

/**
 * 审批状态
 */
export enum PartnerApproveStatus {
  /** 未审核 */
  Unreviewed = 0,
  /** 审核中 */
  Pending = 1,
  /** 审批拒绝 */
  Rejected = 2,
  /** 审核通过 */
  Approved = 3,
}
